import { render, staticRenderFns } from "./GridCellClickable.vue?vue&type=template&id=f0c0c14c&scoped=true&"
import script from "./GridCellClickable.vue?vue&type=script&lang=js&"
export * from "./GridCellClickable.vue?vue&type=script&lang=js&"
import style0 from "./GridCellClickable.vue?vue&type=style&index=0&id=f0c0c14c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c0c14c",
  null
  
)

export default component.exports